// extracted by mini-css-extract-plugin
module.exports = {"tax":"tax_tax__1JEg9"};